module.exports = __webpack_public_path__ + "static/media/1-desktop.f6c745fc.jpg";